import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import db from "../firebase";
import { useState } from "react";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useNavigate } from "react-router-dom/dist";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import AddIcon from '@mui/icons-material/Add';
import { Button, IconButton } from "@mui/material";
import Card from '@mui/material/Card';
import MonthlyReports from "./MonthlyReports";
import VisibilityIcon from '@mui/icons-material/Visibility';

const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#E8EAF6",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
});

export default function Transactions(props) {

  const [rows, setRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState(false);
  const [filterMonth, setFilterMonth] = useState({});
  const months =[
      {
        "name": "January",
        "number": 1
      },
      {
        "name": "February",
        "number": 2
      },
      {
        "name": "March",
        "number": 3
      },
      {
        "name": "April",
        "number": 4
      },
      {
        "name": "May",
        "number": 5
      },
      {
        "name": "June",
        "number": 6
      },
      {
        "name": "July",
        "number": 7
      },
      {
        "name": "August",
        "number": 8
      },
      {
        "name": "September",
        "number": 9
      },
      {
        "name": "October",
        "number": 10
      },
      {
        "name": "November",
        "number": 11
      },
      {
        "name": "December",
        "number": 12
      }
    ];
  

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "transactions");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setRows(docs);
    })();
  }, []);

  // const filteredData = rows.filter((item) => {
  //   const itemMonth = new Date(item.date).getMonth(); 
  //   const currentMonth = new Date().getMonth(); 
  //   return itemMonth === currentMonth;
  // });
    
  //   const filteredRows = rows.filter((row) => {
  //     const searchTermLower = searchTerm.toLowerCase();
    
  //     return (
  //       searchTermLower === "" ||
  //       (row.subject && row.subject.toLowerCase().includes(searchTermLower)) ||
  //       (row.date && row.date.toString().toLowerCase().includes(searchTermLower)) ||
  //       (row.user && row.user.toLowerCase().includes(searchTermLower)) ||
  //       (row.amount && row.amount.toLowerCase().includes(searchTermLower)) ||
  //       (row.description && row.description.toLowerCase().includes(searchTermLower))
  //     );
  //   });
  // const getTotalAmountByStatus = (subject) => {
  //   return filteredRows.reduce((total, item) => {
  //     if (item.subject === subject) {
  //       return total + Number(item.amount);
  //     }
  //     return total;
  //   }, 0);
  // };

  // const totalExpense = getTotalAmountByStatus("Expense");
  // const totalIncome = getTotalAmountByStatus("Income");

  const handleViewClose = () => {
    setView(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setVisible(true);
  };

  const handleReset = () => {
    setSearchTerm("");
    setVisible(false);
  };


  const AddButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: "#1f1966",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#1f1979",
    },
  }));

  const handleNav = () => {
    navigate("/add");
  };

  // const sortedRows = rows.slice().sort((a, b) => {
  //   const dateA = new Date(`1970-01-01 ${a.time}`);
  //   const dateB = new Date(`1970-01-01 ${b.time}`);
  //   return dateB - dateA;
  // });

  const sortedRows = rows.sort((a, b) => {
    const dateA = new Date(a.date.split('/').reverse().join('/'));
    const dateB = new Date(b.date.split('/').reverse().join('/'));
    return dateB - dateA;
  });
  console.log(sortedRows)

  return (
    <div className="home-container">
        <Card sx={{background: "transparent",boxShadow:"none"}} >
                <div style={{width: "10%"}} >
                  <span>Id</span>
                  </div>
                <div style={{width: "20%"}} >
                  <span>Name</span>
                  </div>
                {/* <div style={{width: "20%"}} >
                  <span>Category</span>
                  </div>
                <div style={{width: "15%"}} >
                  <span>Subject</span>
                  </div> */}
                <div style={{width: "19%"}} >
                  <span>Quantity</span>
                  </div>
                <div style={{width: "25%"}} >
                  <span>Updated On</span>
                  </div>
            </Card>
        {sortedRows.map((i) => {
          return(
            <Card key={i.id} 
            sx={{
                background: i.status === "PURCHASED" ? "green" : "red", color: "white"
              }}
             >
                <div style={{width: "10%",fontWeight:"500"}} >
                  <span>{i.productId}</span>
                  </div>
                <div style={{width: "20%",fontWeight:"500"}} >
                  <span>{i.productName}</span>
                  </div>
                {/* <div style={{width: "20%",fontWeight:"500"}} >
                  <span>{i.category}</span>
                  </div>
                <div style={{width: "15%",fontWeight:"500"}} >
                  <span>{i.status}</span>
                  </div> */}
                <div style={{width: "19%",fontWeight:"500"}} >
                  <span>{i.quantity}</span>
                  </div>
                  <div style={{width: "25%"}} >
                  <span>{i.time} - {i.date}</span>
                  </div>
                {/* <div style={{width: "20%", textAlign:"center",color:"blue"}}
                onClick={() => {
                  navigate(`/reports/${i.id}`);
                }} >
                  <span><VisibilityIcon/></span>
                  </div> */}
            </Card>
          )
          })}
    </div>
  );
}
